import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'caret';

const originalDimensions = {
    width: 24,
    height: 24,
};

/**
 * Rotation defaults to downward. The SVG was built with the caret pointing to the right, so any
 * provided rotation is offset by adding 90.
 */
export const IconCaret = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, rotation = 0 } = props;
    const classNames = cx(addClasses, 'inline');

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Caret Icon</title>
            <g
                fill="none"
                fillRule="evenodd"
                transform={`rotate(${rotation + 90},12,12)`}
            >
                <path d="M0 0h24v24H0z" />
                <path
                    d="M9.829 18.277l6.74-5.88a.5.5 0 00.002-.752L9.83 5.728a.5.5 0 00-.83.376V17.9a.5.5 0 00.829.377z"
                    fill={fill}
                />
            </g>
        </svg>
    );
};
